<template>
  <div>
    <PageHeader title="Devis" />
    <div class="mb-5 px-4 py-2 bg-white shadow rounded-lg">
      <Selector
        class="mb-4"
        id="store-selector"
        name="store"
        label="Magasin"
        :options="storeOptions"
        v-model="selectedStoreId"
      />
    </div>
    <LeadsIndex :storeId="selectedStoreId" />
  </div>
</template>

<script>
import LeadsIndex from "@/components/leads/LeadsIndex.vue";
import { PageHeader, Selector } from "@estaly/ui";
import { mapState } from "vuex";

export default {
  components: {
    PageHeader,
    LeadsIndex,
    Selector,
  },
  data() {
    return {
      selectedStoreId: null,
    };
  },
  computed: {
    ...mapState("store", ["stores"]),
    storeOptions() {
      return this.stores.map((store) => ({
        value: store.id,
        label: store.salesChannel || store.name,
      }));
    },
  },
  mounted() {
    if (this.stores.length > 0) {
      this.selectedStoreId = this.stores[0].id;
    }
  },
};
</script>
